import { UserRole } from '../../auth/models/user.model';

export class UserData {
  constructor(
    public id?: string,
    public birthDate?: string,
    public countryRegion?: string,
    public department?: string,
    public email?: string,
    public firstName?: string,
    public lastName?: string,
    public middleName?: string,
    public password?: string,
    public passwordConfirm?: string,
    public phoneNumber?: string,
    public title?: string,
    public organizationId?: string,
    public organizationName?: string,
    public username?: string,
    public invitationSent?: boolean,
    public status?: string,
    public roles?: UserRole[],
    public freemium?: boolean,
    public groupPermissions?: {
      permission: string;
      permissionExtended?: string[];
    }[]
  ) {}
}
